/// <reference path="../../../services/data.service.ts" />
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SrvLocationService } from '../../../services/SrvLocation.service';
import { PasService } from '../../../services/pas.service';
import { PermissionsService } from 'src/services/PermissionsService';
import { ProductionService } from '../../../services/production.service';
import { RouterService } from '../../../services/router.service';
import { UserService } from '../../../services/user.service';
import { Icc } from '../../Interfaces/icc';
import { IdatatableResponse } from '../../Interfaces/idatatable';
import { ServiceLocationData } from '../../Interfaces/ilocation';
import { CommanderCancel, ICommanderHData } from '../../Interfaces/iproduction';
import { IuserPermissionsResponse } from '../../Interfaces/iuser';
import { ErrorStateMatcher1 } from '../../error-state-matcher1';

@Component({
  selector: 'app-commanderlist',
  templateUrl: './commanderlist.component.html'
})

export class CommanderListComponent implements OnInit {

  filterForm: FormGroup;
  subRef$: Subscription;

  r_gridregs: 0;
  public companyId: string;
  userId: string;
  matcher = new ErrorStateMatcher1();
  message: string = "";
  vp_OrderDate :string = "";
  Columns: string[] = [];
  DataGrid: ICommanderHData[] = [];
  dataList = null;
  Permissions: IuserPermissionsResponse[] = [];
  MenuG: IuserPermissionsResponse[] = [];
  permissionsList = null;
  menuGList = new MatTableDataSource;
  menuPop: IuserPermissionsResponse[] = [];
  menuPopList = new MatTableDataSource;
  filtermenu = { type: 'G' };
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  ngAfterViewInit() {
    this.dataList.paginator = this.paginator;
  }

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    //private dataService: DataService,
    //private securityService: SecurityService,
    //private companyservice: CompanyService,
    private routeparent: RouterService,
    private passervice: PasService,
    private _snackBar: MatSnackBar,
    private userService: UserService,
    private permissionService: PermissionsService,
    //private ccService: CcService,
    private srvLocationService: SrvLocationService,
    private productionService: ProductionService,
    private securityParams: ActivatedRoute, 
  ) {
    this.filterForm = formBuilder.group({
      zone: [0,[Validators.min(0), Validators.max(20)]],
      srvLocationId: [0],
      status: ['*',Validators.required],
      attendingUserId: [0],
      startDate: [new Date(), Validators.required],  //new Date().toISOString().substring(0, 10)
      endDate: [new Date(), Validators.required],  //.toISOString().substring(0, 10)
      validator: ['x', Validators.required]
    });
    this.Columns = ['docDate', 'docNumber', 'locationName','attendingUserName', 'statusName','b_menu'];
  }
  selectedvalue: number; selectedview: string;
  cc: Icc[];
  srvLocations: ServiceLocationData[];
  ccId: number = 0;
  cmdStates: IdatatableResponse[];
  _CurrentId: number;


  ngOnInit() {
    this.ccId = parseInt(this.securityParams.snapshot.params.ccid);
    this.message = "";
    //this.dataList.paginator =0;

    //permisos
    this.Permissions = [];
    this.MenuG = [];
    this.menuPop = [];

    this.permissionService.getPermission("CMDLIST").subscribe(results => {
      if (results.body.length == 0)
        this.message = "No tiene permisos";
      for (const entry of results.body) {
        this.addPermission({ id: entry.id, function_code: entry.function_code, code: entry.code, description: entry.description, type: entry.type, icon: entry.icon, link: entry.link });
      }
      this.permissionsList = new MatTableDataSource<IuserPermissionsResponse>(this.Permissions);
      this.menuGList = new MatTableDataSource<IuserPermissionsResponse>(this.MenuG);
      this.menuPopList = new MatTableDataSource<IuserPermissionsResponse>(this.menuPop);

    },
      (e) => {
        this.message = e.error;
        console.log(e);
      });
    //srvlocations
    this.srvLocations = [];
    this.srvLocationService.GetServiceLocations(this.ccId, 0).subscribe(result => {
      if (result.body.isValid) {
        this.addLocation({id:0, name:"Todos"});
        for (const entry of result.body.resultData) {
          this.addLocation(entry);
        }
      }
      else {
        this.openSB(result.body.error.description);
        this.message = result.body.error.description;
      }
    }, (e) => {
      console.log(e);
    });//commander states
    this.cmdStates = [];
    this.productionService.GetCommanderStates().subscribe(result => {
      if (result.body.isValid) {
        this.addStatus({ code: "*", textvalue: "Todos" } )
        for (const entry of result.body.resultData) {
          this.addStatus(entry);
        }
      }
      else {
        this.openSB(result.body.error.description);
        this.message = result.body.error.description;
      }
    }, (e) => {
      console.log(e);
    });
  }

  Filter() {
    this.message = "Procesando...";
    this.filterForm.controls['validator'].setValue('');
    this.DataGrid = [];
    this.r_gridregs = 0;
    //const url = environment.urlAPI + 'api/inventory/v1/orderscc/';
    //var x = new Date(this.filterForm.value.startDate)
    this.productionService.GetCommanderHList(this.ccId, this.filterForm.value.zone,
      this.filterForm.value.srvLocationId, this.filterForm.value.attendingUserId, this.filterForm.value.status,
      this.filterForm.value.startDate.toISOString().substring(0, 10), this.filterForm.value.endDate.toISOString().substring(0, 10)).subscribe(results => {
        if (!results.body.isValid) {
          this.openSB(results.body.error.description);
          this.message = results.body.error.description;
        }
        else {
          for (const entry of results.body.resultData) {
            this.addData(entry);
          }
          this.dataList = new MatTableDataSource<ICommanderHData>(this.DataGrid);
          this.dataList.paginator = this.paginator;
          this.r_gridregs = this.dataList.data.length;
        }
        this.message = "";
        this.filterForm.controls['validator'].setValue('x');

    },
      (e) => {
        this.openSB(e.error);
        this.message=e.error;
      });
  }

  addLocation(Data) {
    this.srvLocations.push(Data);
  }

  addStatus(Data) {
    this.cmdStates.push(Data);
  }

  addData(data) {
      this.DataGrid.push(data);
  }

  addPermission(permission) {
    this.Permissions.push(permission);
    switch (permission.type) {
      case "G":
        this.MenuG.push(permission);
        break;
      case "R":
        {
          switch (permission.code) {
            case "D":
              this.menuPop.push(permission);
              break;
            default:
              this.menuPop.push(permission);
              break;
          }
          break;
        }
    }
  //  else {
  //    switch (permission.code) {
  //      case "M": {
  //        this.Columns.push("b_menu");
  //        break;
  //      }
  //    }
  //  }
  }

  FilterLocation() {
    let _Zone = this.filterForm.value.zone;
    if (_Zone == 0)
      return this.srvLocations.filter(x => { return x.id === _Zone }); 
    return this.srvLocations.filter(x => { return x.zone === _Zone ||x.id===0 });
  }


  b_menu(PrmCode: string, Link: string, CurrentId: number) {
    var _cmd = this.DataGrid.find(x => x.id ==CurrentId);
    switch (PrmCode) {
      case "D":
        try {
          if (_cmd.status !== "R") {
            throw new Error("Solo se puede cancelar una comanda registrada")
          }
          var _CancelConfirm = confirm("Desea cancelar la comanda?");
          if (_CancelConfirm) {
            const _Data: CommanderCancel = {
              sourceUpd: "ITK", ithekeId: CurrentId
            }
            this.productionService.CancelCommander(_Data).subscribe(result => {
              if (result.body.isValid) {
                this.openSB("Comanda cancelada");
                _cmd.status = "C"; _cmd.statusName = "Cancelada";
                //this.Filter();
              }
              else {
                this.openSB(result.body.error.description);
              }
            }, (e) => {
              console.log(e);
            });
          }
        }
        catch (error) {
          this.openSB(error.message);
        }
        break;
    }
  }

  b_back() {
    this.router.navigate(['inventory']);
  }


  b_gen(link, id) {
        this.router.navigate([link]);
  }

  openSB(msg) {
    this._snackBar.open(msg, '', {
      duration: 5000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }

  hasError(nombreControl: string, validacion: string) {
    const control = this.filterForm.get(nombreControl);
    return control.hasError(validacion);
  }

  b_CurrentId(Id: number) {
    this._CurrentId = Id;
    //this.appTransferListService.putValues(this.filterForm.value.ccIdFrom, this.filterForm.value.ccIdTo, this.filterForm.value.startDate, this.filterForm.value.endDate, this.filterForm.value.status, this.paginator.pageIndex);
  }
}
